var _path, _path2, _path3, _path4, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWhatsappIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E0E0E0",
    d: "M27.337 4.65A15.868 15.868 0 0016.067 0C7.285 0 .138 7.113.135 15.856a15.77 15.77 0 002.126 7.927L.001 32l8.446-2.205a15.958 15.958 0 007.613 1.93h.007c8.78 0 15.928-7.114 15.932-15.856A15.725 15.725 0 0027.337 4.65zm-11.27 24.397h-.005c-2.377 0-4.707-.636-6.74-1.837l-.484-.286-5.012 1.309 1.338-4.864-.315-.498a13.11 13.11 0 01-2.024-7.014C2.828 8.59 8.768 2.678 16.072 2.678c3.537.002 6.862 1.374 9.362 3.865s3.876 5.803 3.875 9.325c-.003 7.267-5.943 13.18-13.242 13.18z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#whatsapp_icon_svg__whatsapp)",
    d: "M.732 31.088l2.157-7.841A15.081 15.081 0 01.86 15.68C.864 7.338 7.685.551 16.065.551a15.136 15.136 0 0110.754 4.437 15.006 15.006 0 014.45 10.705c-.004 8.344-6.825 15.132-15.204 15.132h-.006c-2.545 0-5.045-.636-7.266-1.841l-8.06 2.104z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M12.13 9.125c-.295-.653-.605-.666-.886-.677-.229-.01-.492-.01-.754-.01s-.689.099-1.05.49c-.36.393-1.377 1.34-1.377 3.268 0 1.928 1.41 3.79 1.607 4.052.197.261 2.723 4.343 6.722 5.913 3.325 1.306 4.001 1.046 4.723.98.721-.065 2.328-.947 2.656-1.862.328-.915.328-1.698.23-1.862-.1-.164-.361-.262-.755-.458-.394-.195-2.328-1.143-2.689-1.274-.36-.13-.623-.196-.885.196-.263.392-1.017 1.274-1.246 1.536-.23.261-.46.294-.853.098-.393-.196-1.66-.61-3.164-1.944-1.17-1.039-1.96-2.321-2.19-2.713-.23-.392-.024-.604.173-.8.177-.175.394-.457.59-.686.197-.229.263-.392.394-.653.13-.262.065-.49-.033-.686-.098-.196-.863-2.134-1.213-2.908z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27.206 4.6A15.69 15.69 0 0016.066.003C7.383.003.318 7.035.315 15.677a15.594 15.594 0 002.102 7.837L.184 31.636l8.349-2.18c2.3 1.25 4.89 1.907 7.525 1.908h.007c8.68 0 15.746-7.032 15.75-15.674a15.55 15.55 0 00-4.61-11.09zm-11.14 24.117h-.006a13.112 13.112 0 01-6.662-1.816l-.479-.282-4.954 1.293 1.323-4.808-.312-.492a12.958 12.958 0 01-2.001-6.934C2.978 8.495 8.85 2.651 16.07 2.651a13.034 13.034 0 019.255 3.82 12.923 12.923 0 013.83 9.218c-.003 7.183-5.875 13.028-13.09 13.028z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "whatsapp_icon_svg__whatsapp",
    x1: 16,
    x2: 16,
    y1: 31.088,
    y2: 0.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20B038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D66A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "whatsapp_icon_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
}

export default SvgWhatsappIcon;